import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  public setItem(key: string, val: any): void {
    localStorage.setItem(key, JSON.stringify(val));
  }

  public getItem(key: string): any {
    return JSON.parse(localStorage.getItem(key));
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public clear(): void {
    localStorage.clear();
  }
}
